import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { getLocaleName } from '@/stores/setting.store.ts';

import cy from './locales/cy-GB.json';
// Import translation files
import en from './locales/en-GB.json';
import zh from './locales/zh-CN.json';

const resources = {
  'en-GB': {
    translation: en,
  },
  'zh-CN': {
    translation: zh,
  },
  'cy-GB': {
    translation: cy,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: getLocaleName(), // Use full localeName (e.g., en-GB, zh-CN)
  fallbackLng: 'en-GB',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
